const QUERY_TO_FILTER_KEY = {
  brand: 'brand_id',
  cid: 'cat_id',
  shop: 'shop_id',
  sku: 'sku_id',
}

const QUERY_KEYS = [
  'brand',
  'cid',
  'plat',
  'item_id',
  'sku',
  'content_word',
  'price_min',
  'price_max',
  'shop',
  'fx_url_id',
]

export function buildSafeFilterParams(baseFilterParams, routeQuery = {}) {
  if (baseFilterParams && typeof baseFilterParams === 'object') {
    return JSON.parse(JSON.stringify(baseFilterParams))
  }

  return QUERY_KEYS.reduce((params, key) => {
    const value = routeQuery ? routeQuery[key] : undefined
    if (value === undefined || value === null || value === '') {
      return params
    }

    params[QUERY_TO_FILTER_KEY[key] || key] = value
    return params
  }, {})
}
